/* eslint-disable */
import { CommonModule } from '@angular/common';
import { Component, ElementRef, EventEmitter, inject, input, Input, InputSignal, Output, ViewChild, ChangeDetectionStrategy, OnInit } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { RouterModule } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { SvgIconComponent } from '@k12/ui-primitives';
import { BannerConfig } from '@k12/models';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'app-banner',
  imports: [CommonModule, MatButtonModule, MatIconModule, RouterModule, SvgIconComponent],
  templateUrl: './banner.component.html',
  styleUrls: ['./banner.component.scss']
})
export class BannerComponent implements OnInit {
  @ViewChild('previewBanner') previewBanner!: ElementRef<HTMLSpanElement>;

  @Input() configs: BannerConfig[] = [];
  @Output() dismissBanner = new EventEmitter<BannerConfig>();

  public allowPointerEvents: InputSignal<boolean> = input(true);
  public previewBannerMessage: SafeHtml;
  public visibleBanners: Set<string> = new Set();

  private sanitizer = inject(DomSanitizer);

  public ngOnInit(): void {
    this.configs.forEach((config) => {
      if (config.category) {
        this.previewBannerMessage = this.sanitizer.sanitize(1, config.message) ?? '';
      }
    });
  }

  public dismiss(config: BannerConfig): void {
    this.dismissBanner.emit(config);
  }

  public getColorClass(config: BannerConfig): string {
    return `banner-${config.type.type}`;
  }

  // Normalize non-breaking-space entities to regular spaces.
  // Without this, CSS word-breaking (for long banner text) does not work correctly.
  public normalizeMessage(message?: string): string {
    return (message ?? '')
      .replace(/&nbsp;/gi, ' ')
      .replace(/&#160;/gi, ' ')
      .replace(/\u00A0/g, ' ');
  }

  public isVisible(config: BannerConfig): boolean {
    return !this.visibleBanners.has(config.id);
  }
}
